import React, { useEffect, useState } from 'react';

import _ from 'lodash';
import { FormControl, FormHelperText, InputLabel, useTheme } from '@material-ui/core';

import { buildImageUrl, call, classes } from 'utils';
import { ImageSelectorDialog } from 'routes/Dashboard/ImageLibrary';

import styles from './ImageInput.module.scss';

const ImageInput = props => {
  const [dialog, setDialog] = useState();
  const theme = useTheme();

  const { name, error, value = {} } = props;

  const helperText =
    (typeof props.helperText === 'string'
      ? props.helperText
      : (props.helperText || {}).image) || ' ';

  useEffect(() => {
    if (dialog === false) {
      call(props.onBlur, { target: { name } });
    }
  }, [name, dialog]);

  return (
    <div className={styles.input}>
      <FormControl required={props.required} fullWidth={props.fullWidth} error={error}>
        <InputLabel htmlFor={name} shrink={!!value.image}>
          {props.label}
        </InputLabel>

        <div
          className={classes(styles.content, error ? styles.error : '')}
          style={error ? { borderColor: theme.palette.error.main } : undefined}
          onClick={() => setDialog(true)}
        >
          <div
            className={styles.image}
            style={
              value.imageUrl ? { backgroundImage: `url(${value.imageUrl})` } : undefined
            }
          />
        </div>

        <FormHelperText error>{error && helperText ? helperText : ' '}</FormHelperText>
      </FormControl>

      <ImageSelectorDialog
        open={!!dialog}
        onClose={() => setDialog(false)}
        onChange={data => {
          setDialog(false);

          call(props.onChange, {
            type: 'change',
            target: {
              name,
              value: {
                image: data._id,
                imageUrl: buildImageUrl(data, false),
                imageContentType: _.get(data, 'metadata.contentType'),
              },
            },
          });
        }}
      />
    </div>
  );
};

export default ImageInput;
